var _path, _rect, _rect2, _path2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path3, _path4, _line11, _line12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolioIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 68,
    viewBox: "0 0 79 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0131 4.39374L42.9522 10.7296C40.5605 11.9006 39.326 15.2425 40.7318 18.1138L36.0519 20.4052C34.6507 17.5433 31.0966 16.6761 28.7987 17.8012L31.0131 4.39374ZM31.0131 4.39374L34.4077 11.3271",
    stroke: "white",
    strokeWidth: 1.75947
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.7045,
    y: 22.4916,
    width: 8.99412,
    height: 0.973682,
    transform: "rotate(-26.0869 34.7045 22.4916)",
    stroke: "white",
    strokeWidth: 0.879736
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7093,
    y: 24.7184,
    width: 9.49152,
    height: 13.7584,
    transform: "rotate(-26.0869 35.7093 24.7184)",
    stroke: "white",
    strokeWidth: 2.63921
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9941 11.8192C36.216 12.2724 36.0041 12.928 35.3721 13.2374C34.7402 13.5468 34.0924 13.3122 33.8705 12.8589C33.6485 12.4056 33.8605 11.7501 34.4924 11.4407C35.1244 11.1313 35.7722 11.3659 35.9941 11.8192Z",
    stroke: "white",
    strokeWidth: 0.879736
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.1885,
    y: 7.94592,
    width: 11.929,
    height: 28.5924,
    rx: 1.29314,
    transform: "rotate(29.2743 59.1885 7.94592)",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64.1359,
    y1: 13.5917,
    x2: 66.1683,
    y2: 14.7683,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 62.9333,
    y1: 15.7065,
    x2: 63.4928,
    y2: 16.0305,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 61.7307,
    y1: 17.8213,
    x2: 63.7631,
    y2: 18.9979,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 60.5281,
    y1: 19.9361,
    x2: 61.0877,
    y2: 20.2601,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 59.3256,
    y1: 22.051,
    x2: 61.358,
    y2: 23.2277,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 58.123,
    y1: 24.1659,
    x2: 58.6825,
    y2: 24.4898,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 56.9205,
    y1: 26.2806,
    x2: 58.9529,
    y2: 27.4573,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 55.7179,
    y1: 28.3955,
    x2: 56.2774,
    y2: 28.7194,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 54.5153,
    y1: 30.5104,
    x2: 56.5478,
    y2: 31.687,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 53.3127,
    y1: 32.6252,
    x2: 53.8723,
    y2: 32.9492,
    stroke: "#170F0F",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6893 29.5339C17.6893 28.8197 18.2682 28.2407 18.9824 28.2407H62.3412C63.0554 28.2407 63.6343 28.8197 63.6343 29.5339V33.8148C63.6343 34.5615 63.0037 35.153 62.2586 35.1053L18.8997 32.3279C18.2191 32.2843 17.6893 31.7195 17.6893 31.0374V29.5339Z",
    fill: "#D2E0F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5471 30.6685V31.2027C24.5471 33.7023 26.5734 35.7287 29.073 35.7287H59.5537C59.9108 35.7287 60.2003 36.0182 60.2003 36.3753V63.6989C60.2003 64.0559 59.9108 64.3454 59.5537 64.3454H4.87286C4.51577 64.3454 4.22629 64.0559 4.22629 63.6989V31.3151C4.22629 30.958 4.51576 30.6685 4.87285 30.6685L24.5471 30.6685Z",
    stroke: "white",
    strokeWidth: 6.46568
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 43.8797,
    y1: 52.3559,
    x2: 52.392,
    y2: 52.3559,
    stroke: "white",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 43.8797,
    y1: 55.6503,
    x2: 52.392,
    y2: 55.6503,
    stroke: "white",
    strokeWidth: 1.29314,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon);
export default __webpack_public_path__ + "static/media/portfolioIcon.bc5d73e8753606897256fad34c980e62.svg";
export { ForwardRef as ReactComponent };